import styled from 'styled-components';
import { Box, Typography, useTheme } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';

interface Props {
  uuid: string;
  type: string;
  kind?: string;
  url?: string;
  label?: string;
  id?: string;
  platformId?: number;
  company?: string;
}

const ListContainer = styled.div`
  display: flex;
  padding: ${(props) => props.theme.spacing(2)} ${(props) => props.theme.spacing(1)}
    ${(props) => props.theme.spacing(1)} ${(props) => props.theme.spacing(1)};

  :not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.palette.primary.main};
  }
`;

const MonitoringJobItem: FC<Props> = ({ uuid, type, kind, url, label }) => {
  const theme = useTheme();
  const [platform, setPlatform] = useState('');

  const extractPlatform = (url: string) => {
    const urlParts = url.split('.');
    setPlatform(urlParts[1]);
  };

  useEffect(() => {
    if (!url) return;
    extractPlatform(url);
  }, [url]);

  return (
    <ListContainer>
      <Box
        sx={{
          flexDirection: 'column',
          justifyContent: 'center',
          flexGrow: 2,
          maxWidth: 350,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', mb: theme.spacing(1) }}>
          <Typography
            sx={{ color: theme.palette.text.secondary, mt: theme.spacing(2) }}
            variant="subtitle2"
          >
            {label}
          </Typography>
          <Typography
            sx={{ color: theme.palette.text.secondary, mt: theme.spacing(2) }}
            variant="subtitle2"
          >
            {platform === undefined ? 'google' : platform}
          </Typography>
          <Typography
            sx={{ color: theme.palette.text.secondary, mt: theme.spacing(2), mb: theme.spacing(2) }}
            variant="subtitle2"
          >
            {url}
          </Typography>
          <Typography
            sx={{
              fontWeight: 700,
              lineHeight: theme.typography.caption.lineHeight,
              mt: theme.spacing(1),
            }}
            variant="overline"
          >
            UUID
          </Typography>
          <Typography
            sx={{ color: theme.palette.text.secondary }}
            variant="subtitle2"
          >
            {uuid}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', mb: theme.spacing(1) }}>
          <Typography
            sx={{ fontWeight: 700, lineHeight: theme.typography.caption.lineHeight }}
            variant="overline"
          >
            TYPE
          </Typography>
          <Typography
            sx={{ color: theme.palette.text.secondary }}
            variant="subtitle2"
          >
            {type}
          </Typography>
        </Box>
        {kind && (
          <Box sx={{ display: 'flex', flexDirection: 'column', mb: theme.spacing(1) }}>
            <Typography
              sx={{ fontWeight: 700, lineHeight: theme.typography.caption.lineHeight }}
              variant="overline"
            >
              KIND
            </Typography>
            <Typography
              sx={{ color: theme.palette.text.secondary }}
              variant="subtitle2"
            >
              {kind}
            </Typography>
          </Box>
        )}
      </Box>
    </ListContainer>
  );
};

export default MonitoringJobItem;
